import { fromJS } from 'immutable';

import { LOGOUT } from 'app/redux/modules/auth';

const ENDPOINT = '/api/users';

const LIST_INIT = 'users/LIST_INIT';
const LIST_SUCCESS = 'users/LIST_SUCCESS';
const LIST_FAILED = 'users/LIST_FAILED';
const UPDATE_INIT = 'users/UPDATE_INIT';
const UPDATE_SUCCESS = 'users/UPDATE_SUCCESS';
const UPDATE_FAILED = 'users/UPDATE_FAILED';

const initialState = {
  list: fromJS([]),
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST_INIT:
      return {
        ...state,
        loading: true
      };

    case LIST_SUCCESS:
      return {
        ...state,
        list: fromJS(action.payload),
        loading: false
      };

    case LIST_FAILED:
      return {
        ...state,
        list: fromJS([]),
        loading: false
      };

    case UPDATE_SUCCESS: {
      const payload = fromJS(action.payload);
      const idx = state.list.findIndex(
        item => item.get('_id') === payload.get('_id')
      );
      const list = state.list.set(idx, payload);
      return { ...state, list };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}

export function fetchUsers() {
  return {
    types: [LIST_INIT, LIST_SUCCESS, LIST_FAILED],
    promise: client =>
      client.get(`${ENDPOINT}/`).then(({ status, results }) => {
        if (status !== 'OK') {
          throw new Error('Fetch request failed');
        }
        return results;
      })
  };
}

export function updateUser(uuid, data) {
  return {
    types: [UPDATE_INIT, UPDATE_SUCCESS, UPDATE_FAILED],
    promise: client =>
      client
        .post(`${ENDPOINT}/${uuid}`, { data })
        .then(({ status, result }) => {
          if (status !== 'OK') {
            throw new Error('Fetch request failed');
          }
          // TODO: Merge with users ?
          return result;
        })
  };
}
